// import VideoPlayer from "@/components/VideoPlayer";
import { mapGetters, mapMutations } from "vuex";
import Common from "@/common";
import alertHelper from "@/helper/AlertHelper";

export const perfectMoneyMixin = {
  data() {
    return {
      videoAddress: require("/src/assets/videos/payInstruction.mp4"),
      voucherNumber: "",
      paymentId: "",
      showVideo: false,
      voucherActivationNumber: "",
      captchaInput: "",
      captchaKey: "",
      imageBase64: "",
      getCaptchaImagePending: false,
      showAnimation: false,
    };
  },
  computed: {
    ...mapGetters([
      "getPerfectMoneyCurrentPrice",
      "getVersion",
      "getGatewayPendingFlag",
      "getCallBackUrl"
    ]),
    getSiteIdCondition() {
      return Common.siteIdCondition();
    },
    getSiteRatesDisplayCondition() {
        return Common.siteShowRatesCondition();
    },
    getSiteIdFiveCondition() {
      return Common.siteIdFiveCondition;
    },
  },
  methods: {
    ...mapMutations(["setIsCompName"]),
    getCaptchaImage() {
      let windowHost = "";
      if (window.location.host.includes("localhost"))
        windowHost = "caspian-pay.com";
      else windowHost = window.location.host;
      this.getCaptchaImagePending = true;
      this.$http.get(`https://${windowHost}/captcha/api/math`).then(
        (result) => {
          this.imageBase64 = result.body.img;
          this.captchaKey = result.body.key;
          this.getCaptchaImagePending = false;
        },
        (error) => {
          alertHelper.apiErrorAlert("", error.body.message);
          this.getCaptchaImagePending = false;
        }
      );
    },
    submitInfo() {
      if (!this.voucherActivationNumber || !this.voucherNumber) {
        alertHelper.errorAlert("", "لطفا تمامی فیلد هارا به درستی پر کنید");
      } else {
        let windowHost = "";
        if (window.location.host.includes("localhost"))
          windowHost = "caspian-pay.com";
        else windowHost = window.location.host;
        // changing the input values to english digits if they were persian else they remain the same.
        this.captchaInput = this.$options.filters.englishDigits(
          this.captchaInput
        );
        this.voucherActivationNumber = this.$options.filters.englishDigits(
          this.voucherActivationNumber
        );
        this.voucherNumber = this.$options.filters.englishDigits(
          this.voucherNumber
        );
        this.$http
          .post(`https://${windowHost}/api/transactions`, {
            payment_id: this.paymentId,
            gateway: "PERFECT_MONEY",
            ev_number: this.voucherNumber,
            ev_code: this.voucherActivationNumber,
            captcha: this.captchaInput,
            captcha_key: this.captchaKey,
          })
          .then(
            (result) => {
              if (result.status === 201) {
                alertHelper
                  .transactionSuccessAlert(
                    "پرداخت موفق، لطفا این صفحه را نبندید",
                    `Voucher Amount: ${result.data.data.gateway_result.data.VOUCHER_AMOUNT}`,
                    5000
                  )
                  .then(() => {
                    window.location.href = Common.createCallback(
                      result.data.data.payment.callback_url,
                      this.paymentId,
                      1
                    );
                  });
              }
            },
            (error) => {
              this.getCaptchaImage();
              alertHelper.apiErrorAlert("", error.body.message);
            }
          );
        alertHelper.loadingAlert();
      }
    },
    cancelPayment() {
      let paymentId = this.$route.query.id;
      alertHelper.loadingAlert();
      const callBackUrl = this.$store.getters.getCallBackUrl;
      if (callBackUrl) {
        window.location.href = Common.createCallback(
            callBackUrl,
            paymentId,
            0
        );
      } else {
        this.$http.delete(`payments/${paymentId}`).then((result) => {
          window.location.href = Common.createCallback(
              result.data.data.callback_url,
              paymentId,
              0
          );
        });
      }
    },
    openVideoPlayer() {
      setTimeout(() => {
        this.showVideo = !this.showVideo;
      }, 50);
    },
    clickedOutSideOfVideo() {
      this.showVideo = !this.showVideo;
    },
  },
  created() {
    this.paymentId = this.$route.query.id;
    if (!this.paymentId) {
      alertHelper.paymentIdNotValidAlert();
    } else {
      this.setIsCompName("perfectMoney");
      this.getCaptchaImage();
    }
  },
};
